/**
 * We'll load braintree drop-in ui for payments
 */
if (window.searchDesignForm = document.getElementsByClassName('searchDesignFormAutocomplete')) {

    if (searchDesignForm !== undefined && searchDesignForm.length > 0) {
        // try {
        //     easyAutocomplete = require('easy-autocomplete');
        // } catch (e) {
        //     console.error('Unable to load jquery easyAutocomplete plugin' + e);
        //
        // }


        /**
         * Changing the form action based on input
         */
        searchDesignForm[0].addEventListener('submit', function (e) {
            e.preventDefault();
        });
        const formActionUrl = searchDesignForm[0].action;
        if (document.getElementsByClassName("searchDesignInput")[0].value.length > -1) {
            designSearchForm(document.getElementsByClassName("searchDesignInput")[0].value);
        }
        document.getElementsByClassName("searchDesignInput")[0].addEventListener('change', designSearchForm);
        document.getElementsByClassName('searchDesignButtonSubmit')[0].addEventListener('click',function (e) {
            const searchTerm = ((document.getElementById("searchFormInput") !== undefined) ? document.getElementById("searchFormInput").value : e);
            if (searchTerm && searchTerm.length > 1) {
                searchDesignForm[0].submit();
            }
        });
        function designSearchForm(e) {
            const searchTerm = ((e.target !== undefined) ? e.target.value : e);
            if (searchTerm.length > 1) {
                searchDesignForm[0].action = formActionUrl + '/' + searchTerm.replace(/ /g, '-').toLowerCase();
                for (var i = 0; i < searchDesignForm[0].childNodes.length; i++) {
                    if (searchDesignForm[0].childNodes[i].className == "searchDesignButtonSubmit") {
                        const searchDesignFormButton = searchDesignForm[0].childNodes[i];
                        searchDesignFormButton.addEventListener('click', function () {
                            searchDesignForm[0].submit();
                        });
                        break;
                    }
                }
                searchDesignForm[0].addEventListener('submit', function (e) {
                    searchDesignForm[0].submit();
                });
            }
        }

        // function addCommas(nStr) {
        //     nStr += '';
        //     x = nStr.split('.');
        //     x1 = x[0];
        //     x2 = x.length > 1 ? '.' + x[1] : '';
        //     var rgx = /(\d+)(\d{3})/;
        //     while (rgx.test(x1)) {
        //         x1 = x1.replace(rgx, '$1' + ',' + '$2');
        //     }
        //     return x1 + x2;
        // };
        //console.info('Search Design module loaded');
        // jQuery('.easy-autocomplete-container > ul').hide();
        // const options = {
        //     url: function () {
        //         return "api/get-autocomplete-suggestions";
        //     },
        //
        //     getValue: function (element) {
        //         return element.suggested;
        //     },
        //
        //     ajaxSettings: {
        //         dataType: "json",
        //         method: "POST",
        //         data: {
        //             dataType: "json"
        //         }
        //     },
        //
        //     list: {
        //
        //
        //         maxNumberOfElements: 7,
        //         onKeyEnterEvent: function () {
        //             $(".searchDesignInput").val($(".searchDesignInput").getSelectedItemData().suggested);
        //             autoSuggestChangeLinkTo($(".searchDesignInput").getSelectedItemData().url);
        //         },
        //         onClickEvent: function () {
        //             autoSuggestChangeLinkTo($(".searchDesignInput").getSelectedItemData().url);
        //         },
        //         onLoadEvent: function () {
        //             const autoComplete = $(".searchDesignInput");
        //             $(".easy-autocomplete-container > ul li").each(function (index, item) {
        //                 $(item).append('<dfn> ~ ' + addCommas(autoComplete.getItemData(index).designs) + '</dfn>');
        //             });
        //         },
        //
        //
        //         sort: {
        //             enabled: false
        //         }
        //     },
        //
        //     preparePostData: function (data) {
        //         data.searchTerm = $(".searchDesignInput").val();
        //         return data;
        //     },
        //     highlightPhrase: true,
        //
        //     requestDelay: 400
        // };

        // $(".searchDesignInput").easyAutocomplete(options);

        // function autoSuggestChangeLinkTo(filters) {
        //     window.location = window.location.origin + "/templates/" + filters;
        // }

    }

} else {
    //console.info('Search Design module not loaded');
}
